import { Box } from "@mui/material";

import React from "react";
import { ReasonForVisitContainerStyled } from "../../shared/containers/BookingReviewContainer/BookingReviewStyle";

interface IUserContactInfoCard{
  userFirstName: string;
  userLastname: string;
  userEmail: string;
  userPhoneNumber: string;
}

const UserContactInfoCard = ({
  userFirstName,
  userLastname,
  userEmail,
  userPhoneNumber,
}: IUserContactInfoCard) => {
  return (
    <ReasonForVisitContainerStyled sx={{ mb: 0 }}>
      <Box className="childContainer !py-3 px-4 w-full">
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <span className="!font-semibold text-sm">
          Name:
          </span>
          <span className="text-sm">
            {userFirstName + " " + userLastname}
          </span>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <span className="!font-semibold text-sm">
            Email:
          </span>
          <span className="text-sm">
            {userEmail}
          </span>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <span className="!font-semibold text-sm">
            Phone:
          </span>
          <span className="text-sm">
            {userPhoneNumber || "N/A"}
          </span>
        </Box>
      </Box>
    </ReasonForVisitContainerStyled>
  );
};

export default UserContactInfoCard;
